import type { HTMLAttributes } from "react";
import { cn } from "../lib/cn";
import { CollapsibleToggle, useCollapsibleState } from "./collapsible";

type CardProps = HTMLAttributes<HTMLElement> & {
  hazard?: boolean;
  collapsible?: boolean;
  defaultExpanded?: boolean;
  expandLabel?: string;
  collapseLabel?: string;
  toggleClassName?: string;
};

export function Card({
  className,
  hazard = false,
  collapsible = false,
  defaultExpanded,
  expandLabel = "Expand card",
  collapseLabel = "Collapse card",
  toggleClassName,
  children,
  ...props
}: CardProps) {
  const { expanded, toggleExpanded } = useCollapsibleState({ collapsible, defaultExpanded });

  return (
    <section
      className={cn("cf-card", collapsible && expanded && "is-open", className)}
      data-collapsible={collapsible || undefined}
      data-expanded={collapsible ? expanded : undefined}
      data-hazard={hazard}
      {...props}
    >
      {collapsible && !expanded ? null : children}
      {collapsible ? (
        <CollapsibleToggle
          className={toggleClassName}
          expanded={expanded}
          expandLabel={expandLabel}
          collapseLabel={collapseLabel}
          onClick={toggleExpanded}
        />
      ) : null}
    </section>
  );
}
